module.exports = __webpack_public_path__ + "img/pic_subject_politics.27e3398e.png";